import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, message, Select, Tooltip } from "antd";
import * as ReactBootstrap from "react-bootstrap";
import CustomNoResultFound from "../../../../components/ErrorPages/CustomNoResultFound.jsx";
import { useHistory } from "react-router-dom";
import { useAuthContext } from "../../../../common/providers/AuthProvider";
import ApiClient from "../../../../helpers/ApiClient";
import { MinutesToHours } from "./../../../../helpers/MinutesToHours";
import moment from "moment";
import verified from "../../../../assets/images/verify.jpg";

import CancellationPolicy from "./CancellationPolicy";
import "./BusResultCards.scss";
const { Option } = Select;

function tConvert(time) {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
}

const BusCard = (props) => {
  const { user } = useAuthContext();
  const [form] = Form.useForm();
  const [cardsData, setCardsData] = useState([]);
  //const cardsData = props.busResultObject; //props.busResultObject.data.trips;
  const searchId = props.searchId;
  const { origin, destination, origin2, destination2 } = props.otherData;
  const twowaySearchId = props.twowaySearchId;
  const { updateSelectedBusData } = props.gscontext;
  const { selectedBusData } = props.gscontext.state;
  const [selectedSeats, setSelectedSeats] = useState({});
  const [selectedJourneyType, setSelectedJourneyType] = useState("oneWay");
  const [travelType, setTravelType] = useState("oneWay");
  const [selectedPriceFilter, setSelectedPriceFilter] = useState("All");
  let history = useHistory();

  const setFilteredCardData = (data) => {
    if (data) {
      let FilteredData = data.filter((item) => item.isVisible);
      setCardsData(FilteredData);
    }
  };

  const bookingBusData = (selectionObj) => {
    let remainingDataObj = {
      seatsInfo: selectedSeats[selectionObj.busCardId],
      fareInfo: fareValues[selectionObj.busCardId],
    };
    if (travelType === "oneWay") {
      updateSelectedBusData(
        {
          ...selectionObj,
          ...remainingDataObj,
          searchId: searchId,
          origin: origin,
          destination: destination,
        },
        travelType
      );
      form.resetFields();
      sessionStorage.removeItem("BusPassengersDetails");
      sessionStorage.removeItem("BusPaxFormData");
      history.push("/bus-checkout");
    } else {
      if (travelType === "roundTrip" && selectedJourneyType != "roundTrip") {
        updateSelectedBusData(
          {
            ...selectionObj,
            ...remainingDataObj,
            searchId: searchId,
            origin: origin,
            destination: destination,
          },
          "roundTrip1"
        );
        form.resetFields();
        setSelectedJourneyType("roundTrip");
        setFilteredCardData(props.busTwowayObject);
        setActiveTab({});
        setSelectedSeats({});
        props.handleBusFilter(2);
      } else {
        if (
          !(
            selectedBusData[0].seatsInfo.length ===
            remainingDataObj.seatsInfo.length
          )
        ) {
          message.error("Onward and Return seat count should be same", 2);
          return;
        }
        updateSelectedBusData(
          {
            ...selectionObj,
            ...remainingDataObj,
            searchId: twowaySearchId,
            origin: origin2,
            destination: destination2,
          },
          "roundTrip2"
        );
        sessionStorage.removeItem("BusPassengersDetails");
        sessionStorage.removeItem("BusPaxFormData");

        history.push("/bus-checkout");
      }
    }
  };
  const [fareValues, setFareValues] = useState({});
  const [activeTab, setActiveTab] = useState({});
  const [selectedBoardingPoint, setSelectedBoardingPoint] = useState({});
  const [selectedDroppingPoint, setSelectedDroppingPoint] = useState({});

  const [selectTrip, setSelectTrip] = useState({});

  useEffect(() => {
    setTravelType(localStorage.getItem("travelType"));
  }, []);

  const editOnclick = () => {
    setSelectedJourneyType("oneWay");
    setFilteredCardData(props.busResultObject);

    props.handleBusFilter(1);
  };

  const getSortedSeatNumbers = (busCardId) => {
    return selectedSeats[busCardId].length > 0
      ? selectedSeats[busCardId]
        .sort((a, b) => a.SeatNo - b.SeatNo)
        .map((obj) => obj.SeatNo)
        .join(", ")
      : "";
  };

  const calculateFares = () => {
    let fareObj = {};
    for (const property in selectedSeats) {
      let BaseFare = selectedSeats[property].reduce(
        (acc, value) => Number(value.NetFare) + Number(acc),
        0
      );

      /* Calculating total GST fare  */
      let OperatorServiceCharge = selectedSeats[property].reduce(
        (acc, value) => Number(value.OperatorServiceCharge) + Number(acc),
        0
      );

      let Servicetax = selectedSeats[property].reduce(
        (acc, value) => Number(value.Servicetax) + Number(acc),
        0
      );

      let gst = Number(OperatorServiceCharge) + Number(Servicetax);

      /* Calculating both base and GST fares  */

      fareObj[property] = {
        baseFare: Number(BaseFare).toFixed(2),
        gst: Number(gst).toFixed(2),
        totalFare: Number(BaseFare + gst).toFixed(2),
      };
    }
    setFareValues(fareObj);
  };

  useEffect(() => {
    if (selectedSeats !== {}) calculateFares();
  }, [selectedSeats]);

  useEffect(() => {
    if (selectedJourneyType === "oneWay") {
      setFilteredCardData(props.busResultObject);
      if (activeTab !== {}) {
        setActiveTab({});
        setSelectTrip({});
        setSelectedSeats({});
      }
    }
  }, [props.busResultObject]);

  useEffect(() => {
    if (selectedJourneyType === "roundTrip") {
      setFilteredCardData(props.busTwowayObject);
      if (activeTab !== {}) {
        setActiveTab({});
        setSelectTrip({});
        setSelectedSeats({});
      }
    }
  }, [props.busTwowayObject]);

  const onHandleSeatLayout = (busId) => {
    setSelectTrip({});
    let roleType = 3;

    let userID = 1;
    if (user) {
      if (user.UserID) {
        userID = user.UserID;
      }
    }
    if (userID != 1) {
      roleType = 2;
    }
    let seatLayoutParams = {
      searchId: searchId,
      tripId: busId,
      roleType: roleType,
    };
    if (selectedJourneyType === "roundTrip") {
      seatLayoutParams["searchId"] = twowaySearchId;
    }
    ApiClient.post("buses/tripAvailability", seatLayoutParams)
      .then((result) => {
        return result;
      })
      .then((resp) => {
        if (resp.statusCode === 200) {
          const seatsArray = resp.data.seats;
// console.log(seatsArray,"1");
          const lowerBerthArray = seatsArray.filter((Obj) => Obj.zIndex === 0);

          const upperBerthArray = seatsArray.filter((Obj) => Obj.zIndex === 1);
          setSelectTrip({ ...resp, lowerBerthArray, upperBerthArray });
        }
      })
      .catch((err) => { });
  };

  function groupBy(collection, property) {
    var i = 0,
      val,
      index,
      values = [],
      result = [];
    for (; i < collection.length; i++) {
      val = collection[i][property];

      index = values.indexOf(val);
      if (index > -1) result[index].push(collection[i]);
      else {
        values.push(val);
        result.push([collection[i]]);
      }
    }
    return result;
  }

  const PriceFilters = () => {
    const seatsArray = selectTrip.data.seats;
    let seatsData = seatsArray.filter(
      (item) =>
        item.isAvailableSeat === "true" || item.isAvailableSeat === "True"
    );
    var objres = groupBy(seatsData, "fare");

    let groupByPrice = objres.map((item, i) => {
      if (item.length > 0) {
        let { fare } = item[0];
        return {
          fare,
          count: item.length,
        };
      }
    });

    return (
      <>
        {groupByPrice && Object.keys(groupByPrice).length > 1 ? (
          <div className="pricefilter">
            <Button
              className={`filterbtn ${selectedPriceFilter == "All" ? "active" : ""
                }`}
              onClick={() => setSelectedPriceFilter("All")}
            >
              All
              <span className="seatcount"> ({seatsData.length}) </span>
            </Button>

            {groupByPrice.map((item, i) => (
              <Button
                key={i}
                className={`filterbtn ${selectedPriceFilter == item.fare ? "active" : ""
                  }`}
                onClick={() => setSelectedPriceFilter(item.fare)}
              >
                ₹{item.fare} <span className="seatcount"> ({item.count})</span>
              </Button>
            ))}
          </div>
        ) : (
          <div className="emptyspace"></div>
        )}
      </>
    );
  };

  const SeatLayout = (data) => {
    const busCardId = data.busCardId;

    const lowerBerthArray = selectTrip.lowerBerthArray;
    const upperBerthArray = selectTrip.upperBerthArray;

    let uniqueseat = [...new Set(lowerBerthArray.map(col => col.column))]

    let lowerLayoutObj = [];

    let maxRowValueLower = Math.max.apply(
      Math,
      lowerBerthArray.map((o) => {
        return o.row;
      })
    );
    let maxColValueLower = Math.max.apply(
      Math,
      lowerBerthArray.map((o) => {
        return o.column;
      })
    );

    // let maxRows = [];
    // console.log("maxRowss", maxRowss)
    // for (let i = 0; i <= uniqueseat.length; i++) {
    //   maxRows.push(i);
    // }
    let maxColumns = [];
    maxColumns = uniqueseat.sort((a, b) => a - b)

    for (let index = 0; index <= maxRowValueLower; index++) {
      lowerLayoutObj.push(lowerBerthArray.filter((obj) => obj.row === index));
    }
    let upperLayoutObj = [];
    let maxRowValueUpper = Math.max.apply(
      Math,
      upperBerthArray.map((o) => {
        return o.row;
      })
    );

    let maxColValueUpper = Math.max.apply(
      Math,
      upperBerthArray.map((o) => {
        return o.column;
      })
    );

    let uniqUperColumn = [...new Set(upperBerthArray.map(col => col.column))]

    for (let index = 0; index <= maxRowValueUpper; index++) {
      upperLayoutObj.push(upperBerthArray.filter((obj) => obj.row === index));
    }
    let isSeatingRow = false;
    let isSeat = false;
    let isSleepingRow = false;
    let isVerticalRow = false;
    let seatClassName = "";
    let maxUpColumns = [];
    maxUpColumns = uniqUperColumn.sort((a, b) => a - b)
    // for (let i = 0; i <= maxColValueUpper; i++) {
    //   maxUpRows.push(i);
    // }
    // console.log(upperBerthArray, "layout");
    const getSeatClass = (
      busCardId,
      seatNo,
      IsAvailable,
      IsLadiesSeat,
      IsLadiesSeatReserv,
      fare,
      seatType
    ) => {
      let value = "";

      let key = getSeatStatus(
        busCardId,
        seatNo,
        IsAvailable,
        IsLadiesSeat,
        IsLadiesSeatReserv
      );
      switch (key) {
        case "booked":
          value =
            seatType === "seat"
              ? "Booked-seat-type-image no-pointer-events"
              : "booked-sleeper-type-image no-pointer-events";
          break;
        case "selected":
          value =
            seatType === "seat"
              ? "selected-seat-type-image"
              : "selected-sleeper-type-image";
          break;
        case "ladiesBooked":
          value =
            seatType === "seat"
              ? selectedPriceFilter == fare
                ? "ladies-reserved-seat-type-image no-pointer-events"
                : "ladies-reserved-seat-type-image no-pointer-events"
              : selectedPriceFilter == fare
                ? "reserved-ladies-sleeper-type-image no-pointer-events"
                : "reserved-ladies-sleeper-type-image no-pointer-events";

          break;
        case "ladiesRes":
          value =
            seatType === "seat"
              ? selectedPriceFilter == fare
                ? "ladiesRes-reserved-seat-type-image active"
                : "ladiesRes-reserved-seat-type-image"
              : selectedPriceFilter == fare
                ? "reserved-ladiesRes-sleeper-type-image active"
                : "reserved-ladiesRes-sleeper-type-image";

          break;
        case "default":
          value =
            seatType === "seat"
              ? selectedPriceFilter == fare
                ? "available-seat-type-image active"
                : "available-seat-type-image"
              : selectedPriceFilter == fare
                ? "sleeper-seat active"
                : "sleeper-seat";
          break;
        default:
          break;
      }
      return value;
    };

    const getSeatStatus = (
      busCardId,
      seatNo,
      IsAvailable,
      IsLadiesSeat,
      IsLadiesSeatReserv
    ) => {
      // if (IsAvailable !== "True" ) { for test keys
      if (IsAvailable === "false" || IsAvailable === "False") {
        if (IsLadiesSeat == "True" || IsLadiesSeat == "true")
          return "ladiesBooked";
        else return "booked";
      } else if (IsAvailable && isAlreadySelected(busCardId, seatNo)) {
        return "selected";
      } else if (
        IsLadiesSeat == "True" ||
        IsLadiesSeat == "true" ||
        IsLadiesSeatReserv
      ) {
        return "ladiesRes";
      } else {
        return "default";
      }
    };

    const isAlreadySelected = (busCardId, seatNumber) => {
      return selectedSeats[busCardId] &&
        selectedSeats[busCardId].find((seat) => seat.SeatNo === seatNumber)
        ? true
        : false;
    };

    const busAlreadySelected = (busCardId) =>
      selectedSeats.hasOwnProperty(busCardId) ? true : false;

    const addRemoveSeat = (busCardId, seatInfo) => {
      if (!busAlreadySelected(busCardId)) {
        setSelectedSeats({
          ...selectedSeats,
          [busCardId]: [seatInfo],
        });
      } else {
        if (isAlreadySelected(busCardId, seatInfo.SeatNo)) {
          setSelectedSeats({
            ...selectedSeats,
            [busCardId]: selectedSeats[busCardId].filter(
              (data) => data.SeatNo !== seatInfo.SeatNo
            ),
          });
        } else {
          if (selectedSeats) {
            if (
              selectedSeats[busCardId] &&
              selectedSeats[busCardId].length > 5
            ) {
              message.error("Can't Select More Than 6 Seats");
              return;
            }

            if (selectedJourneyType == "roundTrip") {
              if (
                !(
                  selectedSeats[busCardId].length <
                  selectedBusData[0].seatsInfo.length
                )
              ) {
                message.error("Onward and Return seat count should be same", 2);
                return;
              }
            }
          }

          setSelectedSeats({
            ...selectedSeats,
            [busCardId]: [...selectedSeats[busCardId], seatInfo],
          });
        }
      }
    };

    return (
      <div className="seats-layout-block">
        {upperBerthArray.length > 0 && (
          <div className="sleeper-layout-outer">
            <div className="seat-layout-title-block">
              <div className="seat-layout-title-block-inner-data">
                <div className="seat-layout-title-text">
                  <p>Upper</p>
                </div>
              </div>
            </div>
            <div className="seater-seating-arrangement">
              {upperLayoutObj.map((rowData, i) => {

                rowData = rowData.sort((a, b) => a.column - b.column)
                isSeatingRow =
                  rowData.filter(
                    (data) => data.length === 1 && data.width === 1
                  ).length > 0;
                isSleepingRow =
                  rowData.filter(
                    (data) => data.length === 2 && data.width === 1
                  ).length > 0;
                return (
                  <div
                    key={i}
                    className={
                      isSeatingRow
                        ? "inner-seating-container"
                        : isSleepingRow
                          ? "inner-sleeper-container"
                          : "inner-sleeper-container"
                    }
                  >
                    {/* {console.log(isSleepingRow, isSeatingRow, rowData, "data")} */}
                    <div>
                      <ul
                        className={
                          isSeatingRow
                            ? "first-seater-row"
                            : isSleepingRow
                              ? "first-sleeper-row"
                              : ""
                        }
                      >
                        {maxUpColumns.map((ind, i) => {
                          let seatData = rowData.filter((i) => {
                            return i.column == ind;
                          });

                          if (seatData.length > 0) {
                            seatData = seatData[0];
                            isSeat =
                              seatData.length === 1 && seatData.width === 1;
                            isVerticalRow =
                              seatData.length === 1 && seatData.width === 2;
                            seatClassName = isSeat
                              ? getSeatClass(
                                busCardId,
                                seatData.number,
                                seatData.isAvailableSeat,
                                seatData.isLadiesSeat,
                                seatData.isLadiesSeatReserv,
                                seatData.fare,
                                "seat"
                              )
                              : getSeatClass(
                                busCardId,
                                seatData.number,
                                seatData.isAvailableSeat,
                                seatData.isLadiesSeat,
                                seatData.isLadiesSeatReserv,
                                seatData.fare,
                                "sleeper"
                              );
                          }

                          return rowData.length > 0 ? (
                            seatData.length > 0 ? (
                              <li
                                key={i}
                                className={isVerticalRow ? "vertical_seat" : ""}
                              >
                                <div
                                  id={seatData.number}
                                  className={seatClassName}
                                  key={seatData.number}
                                  onClick={() => {
                                    const clasName = typeof document !== "undefined" ?
                                      document.getElementById(seatData.number).className :
                                      seatClassName;
                                    if (
                                      clasName.indexOf("no-pointer-events") ===
                                      -1
                                    ) {
                                      addRemoveSeat(busCardId, {

                                        SeatNo: seatData.number,
                                        NetFare: seatData.fare,
                                        markup: seatData.markup,
                                        Servicetax: seatData.serviceTax
                                          ? seatData.serviceTax
                                          : 0,
                                        OperatorServiceCharge: seatData.operatorServiceCharge
                                          ? seatData.operatorServiceCharge
                                          : 0,
                                        SeatCode: seatData.seatCode,
                                      });
                                    }

                                  }}
                                >
                                  {seatData.number}
                                </div>
                              </li>
                            ) : rowData.length > 1 ? null : (
                              <li key={i}>
                                {/* <div className="available-seat-type-image empty_seat"></div> */}
                                <div className={
                                  isSeatingRow
                                    ? "available-seat-type-image empty_seat"
                                    : isSleepingRow
                                      ? "first-sleeper-row empty_seat_sleeper"
                                      : "first-sleeper-row empty_seat_sleeper"
                                }></div>
                              </li>
                            )
                          ) : null;
                        })}
                      </ul>
                    </div>

                    {rowData
                      ? rowData.length === 0 && (
                        <>
                          <div key={i} className="empty-row"></div>
                          <div key={i + 1} className="empty-row"></div>
                        </>
                      )
                      : null}
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {/* ------------ Lower Code--------- */}
        <div className="seat-layout-outer">
          <div className="seat-layout-title-block">
            <div className="seat-layout-title-block-inner-data">
              <div className="steering-icon">
                <i className="fa fa-circle"></i>
              </div>
              <div className="seat-layout-title-text">
                <p>Lower</p>
              </div>
            </div>
          </div>
          <div className="seater-seating-arrangement">
            {lowerLayoutObj.map((rowData, i) => {
              rowData = rowData.sort((a, b) => a.column - b.column)
              isSeatingRow =
                rowData.filter((data) => data.length === 1 && data.width === 1)
                  .length > 0;
              isSleepingRow =
                rowData.filter((data) => data.length === 2 && data.width === 1)
                  .length > 0;

              return (
                <div
                  key={i}
                  className={
                    isSeatingRow
                      ? "inner-seating-container"
                      : isSleepingRow
                        ? "inner-sleeper-container"
                        : ""
                  }
                >
                  <div className="seat-type-description">
                    <ul
                      className={
                        isSeatingRow
                          ? "first-seater-row"
                          : isSleepingRow
                            ? "first-sleeper-row"
                            : ""
                      }
                    >
                      {maxColumns.map((ind, i) => {
                        let seatData = rowData.filter((i) => {
                          return i.column == ind;
                        });
                        if (seatData.length > 0) {
                          seatData = seatData[0];
                          isSeat =
                            seatData.length === 1 && seatData.width === 1;
                          isVerticalRow =
                            seatData.length === 1 && seatData.width === 2;
                          seatClassName = isSeat
                            ? getSeatClass(
                              busCardId,
                              seatData.number,
                              seatData.isAvailableSeat,
                              seatData.isLadiesSeat,
                              seatData.isLadiesSeatReserv,
                              seatData.fare,
                              "seat"
                            )
                            : getSeatClass(
                              busCardId,
                              seatData.number,
                              seatData.isAvailableSeat,
                              seatData.isLadiesSeat,
                              seatData.isLadiesSeatReserv,
                              seatData.fare,
                              "sleeper"
                            );
                        }
                        return rowData.length > 0 ? (
                          seatData.length > 0 ? (
                            <li
                              key={i}
                              className={isVerticalRow ? "vertical_seat" : ""}
                            >
                              <div
                                // className={seatClassName}
                                id={seatData.number}
                                className={seatClassName}
                                key={seatData.number}
                                onClick={() => {
                                  // const clasName = seatClassName;
                                  const clasName = typeof document !== "undefined" ?
                                    document.getElementById(seatData.number).className :
                                    seatClassName;
                                  if (
                                    clasName.indexOf("no-pointer-events") === -1
                                  ) {

                                    addRemoveSeat(busCardId, {
                                      SeatNo: seatData.number,
                                      NetFare: seatData.fare,
                                      markup: seatData.markup,
                                      Servicetax: seatData.serviceTax
                                        ? seatData.serviceTax
                                        : 0,
                                      OperatorServiceCharge: seatData.operatorServiceCharge
                                        ? seatData.operatorServiceCharge
                                        : 0,
                                      SeatCode: seatData.seatCode,
                                    });
                                  }
                                }}
                              >
                                {seatData.number}
                              </div>
                            </li>
                          ) : rowData.length > 1 ? null : (
                            <li key={i}>
                              {/* <div className="available-seat-type-image empty_seat"></div> */}
                              {/* <div className={
                                isSeatingRow
                                  ? "available-seat-type-image empty_seat"
                                  : isSleepingRow
                                    ? "first-sleeper-row empty_seat_sleeper"
                                    : "first-sleeper-row empty_seat_sleeper"
                              }></div> */}
                            </li>
                          )
                        ) : null;
                      })}
                    </ul>
                  </div>
                      {console.log("here iam")}
{/* {console.log(rowData,"row")} */}
                  {rowData
                    ? rowData.length === 0 && (
                      <>
                        <div key={i} className="empty-row"></div>
                        <div key={i + 1} className="empty-row"></div>
                      </>
                    )
                    : null}
                </div>
              );
            })}
          </div>
        </div>

        <hr />
        {/* ---------- Seat Type Description ------------ */}
        <div className="seat-type-description">
          <ul className="space_between">
            <li>
              <div className="available-seat-type-image"></div>
              <p>Available </p>
            </li>
            <li>
              <div className="selected-seat-type-image" />
              <p>Selected </p>
            </li>

            <li>
              <div className="ladies-reserved-seat-type-image" />
              <p>Booked by Ladies</p>
            </li>
            <li>
              <div className="ladiesRes-reserved-seat-type-image" />
              <p>Reserved for Ladies</p>
            </li>
            <li>
              <div className="Booked-seat-type-image" />
              <p>Booked </p>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  return (
    <div className="card-results-block">
      <img src={verified} alt="verified" />
      {selectedJourneyType === "roundTrip" ? (
        selectedBusData.length > 0 ? (
          <div className="edit-onward">
            <div className="card-results card">
              <div className="card-results-travel-details">
                <Row gutter={[16, 8]} align="middle">
                  <Col md={10} sm={24} xs={24}>
                    <div className="box_area">
                      <div className="onward_wrapper">
                        <p className="title"> Onward</p>
                        <p className="title"> Selection</p>
                      </div>
                      <div className="bus-details">
                        <h2 className="onward-bus-name">
                          {selectedBusData[0].displayName}
                        </h2>
                        <p className="onward-bus-type">
                          {selectedBusData[0].busType}
                        </p>
                      </div>
                    </div>
                  </Col>
                  <Col md={6} sm={8} xs={8}>
                    <p className="edit-timimg-list">
                      {tConvert(selectedBusData[0].departureTime)} -{" "}
                      {tConvert(selectedBusData[0].arrivalTime)}
                    </p>
                    <p className="onward-boarding-point">
                      {selectedBusData[0].boardingTimes.Location} -{" "}
                      {selectedBusData[0].droppingTimes.Location}
                    </p>
                  </Col>
                  <Col md={4} sm={8} xs={8}>
                    <ul className="onward-price">
                      <li>₹ {selectedBusData[0].fareInfo.totalFare}</li>
                      <li>
                        Seat No.{" "}
                        {selectedBusData[0].seatsInfo.map((item, i) => {
                          return <span key={i}>{item.SeatNo}, </span>;
                        })}
                      </li>
                    </ul>
                  </Col>
                  <Col md={4} sm={8} xs={8} style={{ textAlign: "end" }}>
                    <Button onClick={editOnclick} className="tg-primary-btn">
                      Change
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
            <p className="returntext"> Select For Return</p>
          </div>
        ) : null
      ) : null}

      {cardsData.length > 0 ? (
        <div className="resultsScrollWrapper">
          {cardsData.map(
            (cardData, index) =>
              cardData.isVisible && (
                <ReactBootstrap.Card
                  className="card-results"
                  key={"tab_" + index}
                >
                  <div className="card-results-travel-details">
                    <ReactBootstrap.Row className="card-results-row">
                      <ReactBootstrap.Col
                        md="4"
                        sm="12"
                        className="card-results-columns"
                      >
                        <div className="travels-name">
                          <h2>{cardData.displayName}</h2>
                        </div>
                        <div className="selected-bus-type">
                          <p>{cardData.busType}</p>
                        </div>
                      </ReactBootstrap.Col>
                      <ReactBootstrap.Col
                        md="4"
                        sm="12"
                        className="card-results-columns"
                      >
                        <div className="from-to-details">
                          <div className="bus-timings">
                            <ul>
                              <li> {tConvert(cardData.departureTime)}</li>
                              <li className="du-fast">
                                <span>{cardData.duration} </span>
                                {/* {console.log("3",cardData.duration)} */}
                              </li>
                              <li> {tConvert(cardData.arrivalTime)}</li>
                            </ul>
                            {/* <p className="arrivaldate">
                              {moment(cardData.ArrivalDate).format("DD MMM")}{" "}
                            </p> */}
                          </div>
                          <div className="address">
                            <p className="onboard-address">
                              {cardData.boardingPoints[0]
                                ? cardData.boardingPoints[0].Address
                                : ""}
                              {cardData.boardingPoints[0]
                                ? cardData.boardingPoints[0].Landmark
                                : ""}
                            </p>
                            <p className="available-boardingpoints">
                              {cardData.boardingPoints.length} More Boarding
                              Point(s)
                            </p>
                          </div>
                        </div>
                      </ReactBootstrap.Col>
                      <ReactBootstrap.Col
                        md="4"
                        sm="12"
                        className="card-results-columns"
                      >
                        <div className="available-price-details">
                          <div className="starting-price">
                            {cardData.startingFare.split("/").length > 1 ? (
                              <p className="starting-price-text">
                                Starting From
                              </p>
                            ) : null}
                            <p className="starting-price-number">
                              {cardData.startingFare
                                .split("/")
                                .map((item, i, a) => (
                                  <span key={i}>
                                    {i === 0 && "₹"} {item}
                                    {i < a.length - 1 && "/"}
                                  </span>
                                ))}
                            </p>
                          </div>
                          <div className="no-of-seats">
                            <span>{cardData.availableSeats} Seat(s)</span>
                          </div>
                        </div>
                      </ReactBootstrap.Col>
                    </ReactBootstrap.Row>
                  </div>
                  <div className="card-results-tabs-info  d-md-block">
                    <div className="cards-tabs-block">
                      <ReactBootstrap.Tabs
                        activeKey={activeTab[index] ? activeTab[index] : ""}
                        id="controlled-tab"
                        onSelect={(tabKey) => {
                          setActiveTab({
                            [index]: tabKey,
                          });
                          if (tabKey === "selectseats_" + index) {
                            onHandleSeatLayout(cardData.id);
                            setSelectedSeats({});
                            form.resetFields();
                            setSelectedPriceFilter("All");
                          }
                        }}
                      >
                        <ReactBootstrap.Tab
                          eventKey={"boardingpoints_" + index}
                          title="Boarding/Dropping points"
                        >
                          <div className="boarding-dropping-points-tab">
                            <div
                              className="close-btn"
                              onClick={() => {
                                setActiveTab({
                                  [index]: "",
                                });
                              }}
                            >
                              <i className="fa fa-times"></i>
                            </div>
                            <div className="boarding-dropping-points-tab-container">
                              <div className="boarding-points-block">
                                <div className="boarding-points-block-header ">
                                  <h4>Boarding Points</h4>
                                </div>
                                <div className="boarding-points-block-body">
                                  <ul>
                                    {cardData.boardingPoints.map((data, i) => (
                                      <li key={i + data.Time}>
                                        <span className="dot"></span>
                                        <span>
                                          <Tooltip
                                            className="pointTooltip"
                                            overlayClassName="locTooltip"
                                            placement="topLeft"
                                            title={
                                              <span>
                                                {MinutesToHours(data.Time)}{" "}
                                                {data.Location}
                                              </span>
                                            }
                                          >
                                            {MinutesToHours(data.Time)}{" "}
                                            {data.Location}
                                          </Tooltip>
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                              <div className="dropping-points-block">
                                <div className="dropping-points-block-header ">
                                  <h4>Dropping Points</h4>
                                </div>
                                <div className="dropping-points-block-body">
                                  <ul>
                                    {cardData.droppingPoints.map((data, i) => (
                                      <li key={data.Time + i}>
                                        <span className="dot"></span>
                                        <span>
                                          <Tooltip
                                            className="pointTooltip"
                                            overlayClassName="locTooltip"
                                            placement="topLeft"
                                            title={
                                              <span>
                                                {MinutesToHours(data.Time)}{" "}
                                                {data.Location}
                                              </span>
                                            }
                                          >
                                            {MinutesToHours(data.Time)}{" "}
                                            {data.Location}
                                          </Tooltip>
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ReactBootstrap.Tab>
                        <ReactBootstrap.Tab
                          eventKey={"cancellation_" + index}
                          title="Cancellation Policy"
                        >
                          <div className="cancllation-policy-tab">
                            <div
                              className="close-btn"
                              onClick={() => {
                                setActiveTab({
                                  [index]: "",
                                });
                                setSelectedSeats({});
                              }}
                            >
                              <i className="fa fa-times"></i>
                            </div>
                            <div className="cancellation-policy-container">
                              <div className="cancellation-block">
                                <CancellationPolicy
                                  data={cardData.cancellationPolicy}
                                  cancellation={cardData.partialCancellationAllowed}
                                />
                              </div>
                            </div>
                          </div>
                        </ReactBootstrap.Tab>
                        <ReactBootstrap.Tab
                          eventKey={"selectseats_" + index}
                          title="Select Seats"
                          className="seat-selection-block"
                        >
                          <div className="pricefilter_wrapper">
                            {Object.keys(selectTrip).length === 0 ? (
                              <div className="emptyspace"></div>
                            ) : activeTab[index] ? (
                              activeTab[index] === "selectseats_" + index ? (
                                <PriceFilters />
                              ) : null
                            ) : null}

                            <div
                              className="close-btn"
                              onClick={() => {
                                setActiveTab({
                                  [index]: "",
                                });
                              }}
                            >
                              <i className="fa fa-times"></i>
                            </div>
                          </div>

                          <div className="seats_container">
                            <div className="seats_wrapper">
                              {Object.keys(selectTrip).length === 0 ? (
                                "Loading Seat Layout...."
                              ) : activeTab[index] ? (
                                activeTab[index] === "selectseats_" + index ? (
                                  <SeatLayout busCardId={cardData.id} />
                                ) : null
                              ) : null}
                            </div>

                            <div className="boarding-dropping-point-block">
                              <div className="boarding-dropping-point-block-inner">
                                <div className="boarding-dropping-point-block-tabs">
                                  <Form
                                    name={"locSelect" + index}
                                    form={form}
                                    layout="vertical"
                                  >
                                    <Form.Item
                                      label="Boarding Point"
                                      name="boardingPoint"
                                      rules={[
                                        {
                                          required: true,
                                          message: "Choose Boarding Point",
                                        },
                                      ]}
                                    >
                                      <Select
                                        autocomplete="newpassword"
                                        getPopupContainer={(trigger) =>
                                          trigger.parentNode
                                        }
                                        overlayClassName="bdoverlay"
                                        virtual={false}
                                        onSelect={(index) =>
                                          setSelectedBoardingPoint({
                                            ...cardData.boardingPoints[index],
                                          })
                                        }
                                        placeholder="Choose"
                                      >
                                        {cardData.boardingPoints.map(
                                          (data, index) => (
                                            <Option
                                              key={`bp_${index}_${new Date()}`}
                                              value={index}
                                              className="bdpoint"
                                            >
                                              {" "}
                                              <Tooltip
                                                className="pointTooltip"
                                                overlayClassName="locTooltip"
                                                placement="topLeft"
                                                title={
                                                  <span>
                                                    {" "}
                                                    {MinutesToHours(
                                                      data.Time
                                                    )}{" "}
                                                    {data.Location}
                                                  </span>
                                                }
                                              >
                                                {MinutesToHours(data.Time)}{" "}
                                                {data.Location}
                                              </Tooltip>
                                            </Option>
                                          )
                                        )}
                                      </Select>
                                    </Form.Item>
                                    <Form.Item
                                      label="Dropping Point"
                                      name="droppingPoint"
                                      rules={[
                                        {
                                          required: true,
                                          message: "Choose Dropping Point",
                                        },
                                      ]}
                                    >
                                      <Select
                                        autocomplete="newpassword"
                                        getPopupContainer={(trigger) =>
                                          trigger.parentNode
                                        }
                                        virtual={false}
                                        onSelect={(index) =>
                                          setSelectedDroppingPoint({
                                            ...cardData.droppingPoints[index],
                                          })
                                        }
                                        placeholder="Choose"
                                      >
                                        {cardData.droppingPoints.map(
                                          (data, index) => (
                                            <Option
                                              key={`dpp_${new Date()}_${index}`}
                                              value={index}
                                              className="bdpoint"
                                            >
                                              <Tooltip
                                                className="pointTooltip"
                                                overlayClassName="locTooltip"
                                                placement="topLeft"
                                                title={
                                                  <span>
                                                    {" "}
                                                    {MinutesToHours(
                                                      data.Time
                                                    )}{" "}
                                                    {data.Location}
                                                  </span>
                                                }
                                              >
                                                {MinutesToHours(data.Time)}{" "}
                                                {data.Location}
                                              </Tooltip>
                                            </Option>
                                          )
                                        )}
                                      </Select>
                                    </Form.Item>
                                  </Form>

                                  <div className="selected-seat-fare-details">
                                    <ul>
                                      <li>
                                        <p>Seat No.</p>
                                        <p>
                                          {selectedSeats[cardData.id] &&
                                            selectedSeats[cardData.id].length > 0
                                            ? getSortedSeatNumbers(cardData.id)
                                            : ""}
                                        </p>
                                      </li>
                                      <li>
                                        <p>Base Fare</p>
                                        <p>
                                          ₹{" "}
                                          {(Object.keys(fareValues).length === 0 && fareValues.constructor === Object) ? '0.00' : fareValues[cardData.id] &&
                                            fareValues[cardData.id].baseFare}
                                        </p>
                                      </li>
                                      <li>
                                        <p>Operator GST</p>
                                        <p>
                                          ₹{" "}
                                          {(Object.keys(fareValues).length === 0 && fareValues.constructor === Object) ? '0.00' : fareValues[cardData.id] &&
                                            fareValues[cardData.id].gst}
                                        </p>
                                      </li>
                                      <li>
                                        <p>Total Fare</p>
                                        <p>
                                          ₹{" "}
                                          {(Object.keys(fareValues).length === 0 && fareValues.constructor === Object) ? '0.00' : fareValues[cardData.id] &&
                                            fareValues[cardData.id].totalFare}
                                        </p>
                                      </li>
                                    </ul>

                                    <div className="continue-booked-seat-btn">
                                      <Button
                                        disabled={
                                          selectedSeats[cardData.id] &&
                                            selectedSeats[cardData.id].length > 0
                                            ? false
                                            : true
                                        }
                                        onClick={() => {
                                          form
                                            .validateFields()
                                            .then((data) => {
                                              bookingBusData({
                                                busCardId: cardData.id,
                                                displayName:
                                                  cardData.displayName,
                                                busType: cardData.busType,
                                                droppingTimes: selectedDroppingPoint,
                                                boardingTimes: selectedBoardingPoint,
                                                arrivalTime:
                                                  cardData.arrivalTime,
                                                departureTime:
                                                  cardData.departureTime,
                                                duration: cardData.duration,
                                              });
                                            })
                                            .catch((e) => { });
                                        }}
                                      >
                                        Continue Booking
                                      </Button>
                                    </div>
                                  </div>
                                  {/* ) : (
                                  ""
                                )} */}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* </ReactBootstrap.Col> */}
                          {/* </ReactBootstrap.Row> */}
                          {/* </ReactBootstrap.Container> */}
                        </ReactBootstrap.Tab>
                      </ReactBootstrap.Tabs>
                    </div>
                  </div>
                </ReactBootstrap.Card>
              )
          )}
        </div>
      ) : (
        <CustomNoResultFound title={"No Buses Available"} />
      )}
    </div>
  );
};

export default BusCard;
